// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"d1625818","446":"d1625818","470":"136be001"}[chunkId] + ".chunk.css";
};